// Minimal CSV serializer used to replace the vulnerable `csvjson` package
// (GHSA-xq4f-3jxp-qv6m). Reproduces `csvjson.toCSV(rows, { delimiter: ',',
// wrap: false, headers: 'key' })` behavior exactly, quirks included, since
// callers depend on this output shape.

const DELIMITER = ',';

function collectHeaders(rows) {
    const headers = [];
    const seen = new Set();
    for (const row of rows) {
        for (const key of Object.keys(row)) {
            if (!seen.has(key)) {
                seen.add(key);
                headers.push(key);
            }
        }
    }
    return headers;
}

function formatField(value) {
    if (value === undefined) {
        return '';
    }
    if (value === null) {
        return 'null';
    }
    return String(value).replace(/[,\n]/g, '\t');
}

export default function toCsv(rows) {
    if (Array.isArray(rows) && rows.length === 0) {
        return '[]\n';
    }
    if (rows === null) {
        return '\nnull';
    }
    if (rows === undefined) {
        return '\n';
    }

    const headers = collectHeaders(rows);
    const body = rows.map(row => headers.map(key => formatField(row[key])).join(DELIMITER));
    return [headers.join(DELIMITER), ...body].join('\n');
}
